app.directive('keyboard', ['$state', '$filter', '$ionicModal', 'Utils', 'LocaleService',
    function ($state, $filter, $ionicModal, Utils, LocaleService) {
        return {
            scope: {
                data: '<',
                onLoadCallback: '&'
            },
            link: function (scope, element) {
                scope.isShow = true;
                scope.dataModel = angular.copy(scope.data);
                scope.dataModel.model.value = Utils.decimalRound(scope.dataModel.model.value, scope.dataModel.digits || 0);
                scope.isDone = true;
                $ionicModal.fromTemplateUrl('templates/directives/keyboard.html', {
                    scope: scope,
                    animation: 'slide-in-up'
                }).then(function (modal) {
                    scope.modal = modal;
                    scope.openModal();
                });

                LocaleService.wait().then(function (translation) {
                    scope.translation = translation;
                })

                scope.openModal = function () {
                    scope.modal.show();
                };
                scope.closeModal = function () {
                    scope.modal.hide();
                };

                scope.isDone = isButtonDone();
                scope.onClick = function (newVal) {
                    var result = checked(newVal);
                    if (!result) {
                        if (scope.dataModel.model.value.toString().length < scope.dataModel.maxval.toString().length + 1 + scope.dataModel.digits) {
                            if (scope.dataModel.model.value.toString().length === 1 && scope.dataModel.model.value === 0) {
                                scope.dataModel.model.value = '';
                            }
                            scope.dataModel.model.value = [scope.dataModel.model.value, newVal].join('');
                            if (scope.dataModel.model.value.startsWith('.')) {
                                scope.dataModel.model.value = scope.dataModel.model.value.toString().padStart(2, '0');
                            }
                            if(!scope.dataModel.model.value.includes('.')) {
                                scope.dataModel.model.value = parseFloat(scope.dataModel.model.value);
                            }
                        }
                    }
                    scope.isDone = isButtonDone();
                };

                scope.onCancel = function () {
                    //scope.dataModel.model.value = scope.dataModel.minval;
                    scope.dataModel.model.value = '';
                    scope.isDone = isButtonDone();
                };

                scope.onDone = function () {
                    scope.isShow = true;
                    if (scope.dataModel.model.value.toString().endsWith('.')) {
                        scope.dataModel.model.value = checkEnd(scope.dataModel.model.value);
                    }

                    scope.isDone = isButtonDone();
                    scope.onLoadCallback({arg1: scope.dataModel});
                    scope.closeModal();
                };

                function checkEnd(value) {
                    var splitedValue = value.toString().split('.');
                    return (splitedValue[0] && splitedValue[0].length > 0)
                        ? splitedValue[0].toString()
                        : scope.dataModel.minval.toString();
                }

                scope.onDelete = function () {
                    scope.dataModel.model.value = scope.dataModel.model.value.toString().substring(0, scope.dataModel.model.value.toString().length - 1);
                    /* scope.dataModel.model.value = scope.dataModel.model.value.toString().length === 0
                         ? scope.dataModel.minval
                         : scope.dataModel.model.value.toString();*/
                    scope.isDone = isButtonDone();
                };

                scope.onOpen = function () {
                    scope.isShow = false;
                };

                function checked(val) {
                    var data = [scope.dataModel.model.value, val].join('');
                    var regExp = new RegExp('^\\d*(\\.\\d{0,' + scope.dataModel.digits + '})?$');
                    if ((data.split('.').length > 2) || (data > parseFloat(scope.data.maxval)) || (!regExp.test(data))) {
                        return true;
                    }
                    return false;
                }

                function isButtonDone() {
                    return scope.dataModel.model.value.toString().length > 0 ? false : true;
                }

                scope.onClose = function () {
                    scope.isShow = true;
                    scope.onLoadCallback({arg1: null});
                    scope.closeModal();
                }

                element.on('$destroy', function() {
                    if (scope.modal) {
                        scope.closeModal();
                        scope.modal.remove();
                    }
                });
            },
            /*templateUrl: "templates/directives/keyboard.html"*/
        }
    }]);
